<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card color="#58595b" title="Affiliate Link Clicks" offset="0">
          <v-sheet v-if="formOpen" class="mt-2">
            <v-tabs v-model="activeTab" color="grey lighten-1" dark slider-color="black">
              <v-tab ripple>Details</v-tab>
              <v-spacer />
              <v-btn :loading="saving" color="success" @click="save">Save</v-btn>
              <!-- TAB : DETAILS -->
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <v-form ref="featuredListingForm">
                      <v-layout key="form" wrap justify-center>
                        <v-flex xs12>
                          <v-autocomplete
                            v-model="formData.business_id"
                            :items="businesses"
                            item-text="name"
                            item-value="id"
                            label="Business"
                            placeholder="Please select"
                          />
                        </v-flex>
                        <v-flex xs12 class="autoMargin">
                          <span class="subheading">Listing Picture</span>
                          <template v-if="formData.id">
                            <div v-if="formData.imageUrl">
                              <v-img
                                :src="formData.imageUrl"
                                :width="400"
                                :height="200"
                                class="autoMargin"
                              />
                              <v-btn
                                small
                                block
                                color="info"
                                @click="changeImage = true"
                              >Change Image</v-btn>
                            </div>
                            <croppa
                              v-if="!formData.imageUrl || changeImage"
                              v-model="image"
                              :show-loading="true"
                              :width="400"
                              :height="200"
                              :quality="2"
                              canvas-color="#FFF"
                              placeholder-color="#000000"
                              placeholder="Choose listing image"
                              style="width:300px"
                              initial-size="contain"
                            />
                            <div
                              v-if="!formData.imageUrl || changeImage"
                              class="caption text-xs-center"
                            >
                              Use scroll wheel to zoom in / out and drag to
                              reposition.
                            </div>
                          </template>
                          <template v-else>
                            <br />Please save listing before adding a photo
                          </template>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            v-model="formData.title"
                            label="Title"
                            counter="100"
                            maxlength="100"
                          />
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                            v-model="formData.text"
                            label="Listing Text"
                            counter="335"
                            maxlength="335"
                          />
                        </v-flex>
                        <v-flex>
                          <v-select
                            v-model="formData.frontPagePosition"
                            :items="['Not On Frontpage', '1', '2', '3']"
                            label="Front Page Position"
                            placeholder="Please select"
                          />
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
            <v-layout row class="pl-3 pr-3">
              <v-btn v-if="activeTab != 3" :loading="saving" color="success" @click="save">Save</v-btn>
            </v-layout>
          </v-sheet>
          <v-data-table
            v-else
            key="list"
            :headers="headers"
            :items="affiliateLinkClicks"
            hide-actions
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text--darken-3"
                style="color: #4cc7e8"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td v-if="businessById(item.business_id)">{{ businessById(item.business_id).name }}</td>
              <td v-else></td>
              <td>{{ item.fullName }}</td>
              <td>{{ item.timeStamp | moment }}</td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";
  import moment from "moment";

  export default {
    data: () => ({
      imageOrientation: "Landscape",
      impactStoryDialog: false,
      changeImpactStoryImage: false,
      impactStory: {},
      image: null,
      impactStoryImage: null,
      changeImage: false,
      activeTab: null,
      saving: false,
      deleting: false,
      formOpen: false,
      formData: {},
      headers: [
        {
          sortable: true,
          text: "Business",
          value: "business",
        },
        {
          sortable: true,
          text: "Name of User",
          value: "name",
        },
        {
          sortable: false,
          text: "Timestamp",
          value: "timestamp",
        },
      ],
    }),
    computed: {
      ...mapGetters({
        user: "user",
        affiliateLinkClicks: "affiliateLinkClicks/list",
        businessById: "business/businessById",
      }),
    },
    mounted() {
      this.$store.dispatch("affiliateLinkClicks/loadAll");
    },
    methods: {
      toggleForm() {
        if (!this.formOpen) {
          this.formData = {};
        }
        this.formOpen = !this.formOpen;
      },
      open(featuredListing) {
        this.saving = false;
        this.formData = featuredListing;
        this.formOpen = true;
      },
      save() {
        this.saving = true;
        if (this.image && this.image.imageSet) {
          this.image.generateBlob(
            (blob) => {
              this.formData.image = { file: blob };
              this.$store
                .dispatch("featuredListings/save", this.formData)
                .then((featuredListing) => {
                  this.formData.imageUrl = featuredListing.imageUrl;
                  this.changeImage = false;
                  this.saving = false;
                });
            },
            "image/jpeg",
            1
          );
        } else {
          this.$store
            .dispatch("featuredListings/save", this.formData)
            .then((featuredListing) => {
              this.formData.id = featuredListing.id;
              this.saving = false;
            });
        }
      },
      deleteFeaturedListing() {
        this.$confirm(
          "Are you sure you want to delete this featured listing?"
        ).then((res) => {
          if (res) {
            this.deleting = true;
            this.$store
              .dispatch("featuredListings/delete", this.formData.id)
              .then((res) => {
                this.formOpen = false;
                this.deleting = false;
              });
          }
        });
      },
    },
    filters: {
      moment: function (date) {
        return moment.utc(date).local().format("MMMM Do YYYY, h:mm:ss a");
      },
    },
  };
</script>

<style>
  .croppa-container {
    margin-left: auto;
    margin-right: auto;
    position: relative;
  }

  .icon-remove {
    position: absolute;
    top: 5px !important;
    right: -35px !important;
  }

  .croppa-container canvas {
    border: 1px solid;
  }
</style>
